import { ChoiceField } from './ChoiceField';
import type { FormFieldComponent } from './types';

/**
 * `GenericFormCheckboxGroup` for the CMS-agnostic lane, serving **both** providers.
 *
 * The legacy component
 * (`libs/sitecore/components/forms/src/GenericForm/Components/GenericFormCheckboxGroup/GenericFormCheckboxGroup.tsx`)
 * renders a `CheckboxGroup` of `CheckTile`s, one per item of its `items` multilist. The migrated
 * schema (`node_modules/@eneco/cms-sanity-schema/dist/sections/GenericFormCheckboxGroup.js`) has no `items` field at
 * all — only `minimumRequiredChecksNumber`, `name` and the `formFields` family — so there are no
 * choices in the content to show.
 *
 * That is the same position the choice fields are in, so it shares their body. No `formSchema`
 * either: honouring `minimumRequiredChecksNumber` against a group with no checkboxes would make the
 * whole form permanently unsubmittable. See `ChoiceField` for the full reasoning.
 */
const GenericFormCheckboxGroup: FormFieldComponent = () => <ChoiceField family="formFields" role="checkboxGroupFormField" />;

export default GenericFormCheckboxGroup;
